import { render, staticRenderFns } from "./AppSiteLayout.vue?vue&type=template&id=5f481fdc&scoped=true&"
import script from "./AppSiteLayout.ts?vue&type=script&lang=ts&"
export * from "./AppSiteLayout.ts?vue&type=script&lang=ts&"
import style0 from "./AppSiteLayout.scss?vue&type=style&index=0&id=5f481fdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f481fdc",
  null
  
)

export default component.exports